import React from "react";
import { useState } from "react";
import { UserProfile } from "../userProfile";

import { Button, Box, Typography, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { BasicDetails } from "../useraddProfile/basicDetails";
import { FamilyInfo } from "../useraddProfile/familyInformation";
import { EducationDetails } from "../useraddProfile/educationDetails";
import { DocumentInfo } from "../useraddProfile/documentInfo";
import { OtherInfo } from "../useraddProfile/otherInfo";
import { WalletInfo } from "../useraddProfile/walletInfo";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

const steps = [
  "Basic Information",
  "Family Information",
  "Educational Information",
  "Other Information",
  "Documents Information",
];
const stepContent = [
  <BasicDetails />,
  <FamilyInfo />,
  <EducationDetails />,
  <OtherInfo />,
  <DocumentInfo />,

  //  <WalletInfo/>
];

// Styled Step Component (Arrow Shape)
const StepItem = styled("div")(({ active, completed }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  padding: "5px 24px",
  color: active || completed ? "#FFFFFF" : "#A8A8A8",
  backgroundColor: completed ? "#F24464" : active ? "#F24464" : "#E4E4E4",
  border: "1px solid #E4E4E4",
  position: "relative",
  clipPath: "polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%)",
  marginRight: active || completed ? "-8px" : "-8px",
  zIndex: active ? 2 : completed ? 1 : 0,
  transition: "0.3s",
  "&:last-child": {
    marginRight: 0,
  },
  fontSize: "16px",
  fontWeight: "500",
}));
export function AddProfile() {
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();

  const handleNext = () => {
    const basicDetails = localStorage.getItem("basicDetails");
    const familyDetails = localStorage.getItem("familyDetails");
    const educationDetails = localStorage.getItem("educationDetails");
    const otherDetails = localStorage.getItem("otherDetails");
    const documentDetails = localStorage.getItem("documentDetails");
    const walletDetails = localStorage.getItem("walletDetails");

    if (activeStep === 0 && (!basicDetails || basicDetails === "null")) {
      toast.warning("Please save the details before proceeding.");
      return;
    }

    if (activeStep === 1 && (!familyDetails || familyDetails === "null")) {
      toast.warning("Please save the details before proceeding.");
      return;
    }
    if (
      activeStep === 2 &&
      (!educationDetails || educationDetails === "null")
    ) {
      toast.warning("Please save the details before proceeding.");
      return;
    }
    if (activeStep === 3 && (!otherDetails || otherDetails === "null")) {
      toast.warning("Please save the details before proceeding.");
      return;
    }
    if (activeStep === 4 && (!documentDetails || documentDetails === "null")) {
      toast.warning("Please save the details before proceeding.");
      return;
    }

    if (activeStep === 5 && (!walletDetails || walletDetails === "null")) {
      toast.warning("Please save the details before proceeding.");
      return;
    }
    // this for finish button
    if (activeStep === steps.length - 1) {
      // setActiveStep((prev) => prev + 1);
      toast.warning("Please click the Submit button to complete your profile");
      return;
    }

    setActiveStep((prev) => (prev < steps.length - 1 ? prev + 1 : prev));
  };

  // const handleNext = () => {
  //   setActiveStep((prev) => (prev < steps.length - 1 ? prev + 1 : prev));
  // };

  const handleBack = () => {
    setActiveStep((prev) => (prev > 0 ? prev - 1 : prev));
  };
  return (
    <>
      <ToastContainer />
      <div>
        <div className="addProfile-subcontainer">
          {/* stepper data */}

          {/* Stepper Container */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            {steps.map((label, index) => (
              <StepItem
                key={index}
                active={index === activeStep}
                completed={index < activeStep}
              >
                {label}
              </StepItem>
            ))}
          </Box>
         
        </div>
        <div className="d-flex gap-2">

           <Link to="/user-profiles" style={{ textDecoration: "none" }}>
            {" "}
            <div className="bi bi-arrow-left">
             
            </div>
          </Link>
           <span style={{marginTop:'10px',fontSize:'20px',color:'#f24464'}}>Back</span>
        </div>

        {/* Step Content */}
        <Paper elevation={3}>
          {activeStep === steps.length ? (
            <Typography variant="h5" color="green">
              🎉 All Steps Completed! Your form has been submitted.
            </Typography>
          ) : (
            <Typography
              className="stepper-content"
              sx={{ boxShadow: "none", textShadow: "none" }}
            >
              {stepContent[activeStep]}
            </Typography>
          )}
        </Paper>

        {/* Buttons */}
        {/* <Box sx={{ mt: 4 }}>
        <Button  className="prev-button"
          onClick={handleBack}
          disabled={activeStep === 0}
          variant="contained"
          sx={{ mr: 2, backgroundColor: "#F24464" }}
        >
          Previous
        </Button>

        {activeStep === steps.length - 1 ? (
          <Button
            onClick={handleNext}
            variant="contained"
            sx={{ backgroundColor: "#F24464"}}
          >
            Finish
          </Button>
        ) : (
          <Button
            onClick={handleNext}
            variant="contained"
            sx={{ backgroundColor: "#F24464"}}
          >
            Next
          </Button>
        )}
      </Box> */}
        <Box sx={{ mt: 4 }}>
          <Button
            className="prev-button"
            onClick={handleBack}
            disabled={activeStep === 0}
            variant="contained"
            sx={{ mr: 2, backgroundColor: "#F24464" }}
          >
            Previous
          </Button>

          {activeStep === steps.length - 1 ? (
            <Button
              variant="contained"
              disabled
              sx={{ backgroundColor: "#ccc", color: "#000" }}
            >
              Next
            </Button>
          ) : (
            <Button
              onClick={handleNext}
              variant="contained"
              sx={{ backgroundColor: "#F24464" }}
            >
              Next
            </Button>
          )}
        </Box>
      </div>
    </>
  );
}
